import React, { useState, useContext } from "react";
import axios from "axios";
import "./UploadAssets.css";
import ProductContext from "../ProductContext";

const UploadAssets = () => {
  const { products, categories, setCategories, settings } = useContext(ProductContext);
  const [cover, setCover] = useState(null);
  const [logo, setLogo] = useState(null);
  const [message, setMessage] = useState("");
  const [newCategory, setNewCategory] = useState("");
  const [editingCategory, setEditingCategory] = useState(null);
  const [editedCategoryName, setEditedCategoryName] = useState("");

  // Função para obter o token armazenado
  const getToken = () => localStorage.getItem("token");

  const handleUpload = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    if (cover) formData.append("cover", cover);
    if (logo) formData.append("logo", logo);

    try {
      const token = getToken();
      await axios.post("https://cardapio.olympicbarbacena.com.br/api/settings", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });
      setMessage("Upload realizado com sucesso!");
    } catch (error) {
      console.error("Erro ao realizar upload:", error);
      setMessage("Erro ao realizar upload. Tente novamente.");
    }
  };

  const handleAddCategory = async () => {
    if (!newCategory.trim()) {
      setMessage("O nome da categoria não pode estar vazio.");
      return;
    }

    try {
      const token = getToken();
      const response = await axios.post(
        "https://cardapio.olympicbarbacena.com.br/api/categories",
        { name: newCategory },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setCategories([...categories, response.data]);
      setNewCategory("");
      setMessage("Categoria adicionada com sucesso!");
    } catch (error) {
      console.error("Erro ao adicionar categoria:", error);
      setMessage("Erro ao adicionar categoria.");
    }
  };

  const handleEditCategory = async (id) => {
    if (!editedCategoryName.trim()) {
      setMessage("O nome da categoria não pode estar vazio.");
      return;
    }

    try {
      const token = getToken();
      const response = await axios.put(
        `https://cardapio.olympicbarbacena.com.br/api/categories/${id}`,
        { name: editedCategoryName },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setCategories(categories.map((category) => (category._id === id ? response.data : category)));
      setEditingCategory(null);
      setEditedCategoryName("");
      setMessage("Categoria editada com sucesso!");
    } catch (error) {
      console.error("Erro ao editar categoria:", error);
      setMessage("Erro ao editar categoria.");
    }
  };

  const handleDeleteCategory = async (id) => {
    const confirmDelete = window.confirm(
      "Tem certeza de que deseja excluir esta categoria? Esta ação não pode ser desfeita."
    );

    if (!confirmDelete) {
      setMessage("Exclusão cancelada.");
      return;
    }

    try {
      const token = getToken();
      await axios.delete(`https://cardapio.olympicbarbacena.com.br/api/categories/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setCategories(categories.filter((category) => category._id !== id));
      setMessage("Categoria excluída com sucesso!");
    } catch (error) {
      console.error("Erro ao excluir categoria:", error);
      setMessage("Erro ao excluir categoria.");
    }
  };

  // Função para contar produtos por categoria
  const countProductsByCategory = (categoryName) => {
    return products.filter((product) => product.category === categoryName).length;
  };

  return (
    <div className="upload-assets-container">
      <h2>Configurações do Sistema</h2>
      {message && <p className="upload-message">{message}</p>}

      {/* Upload da Capa e Logo */}
      <form onSubmit={handleUpload} className="upload-assets-form">
        <div className="upload-field">
          <label htmlFor="cover">Atualizar capa:</label>
          {settings.cover && (
            <img
              className="upload-cover"
              src={`https://cardapio.olympicbarbacena.com.br${settings.cover}`}
              alt="Capa do Cardápio"
            />
          )}
          <input type="file" id="cover" onChange={(e) => setCover(e.target.files[0])} />
        </div>
        <div className="upload-field">
          <label htmlFor="logo">Atualizar logo:</label>
          {settings.logo && (
            <img
              className="upload-logo"
              src={`https://cardapio.olympicbarbacena.com.br${settings.logo}`}
              alt="Logo"
            />
          )}
          <input type="file" id="logo" onChange={(e) => setLogo(e.target.files[0])} />
        </div>
        <button type="submit" className="upload-button">Enviar</button>
      </form>

      {/* Gerenciamento de Categorias */}
      <div className="categories-section">
        <h3>Categorias</h3>
        <ul className="categories-list">
          {categories.map((category) => (
            <li key={category._id} className="category-item">
              {editingCategory === category._id ? (
                <div className="edit-category">
                  <input
                    type="text"
                    value={editedCategoryName}
                    onChange={(e) => setEditedCategoryName(e.target.value)}
                    placeholder="Editar Nome"
                  />
                  <button onClick={() => handleEditCategory(category._id)} className="save-category-button">
                    Salvar
                  </button>
                  <button onClick={() => setEditingCategory(null)} className="cancel-category-button">
                    Cancelar
                  </button>
                </div>
              ) : (
                <>
                  <span>
                    {category.name} ({countProductsByCategory(category.name)} produtos)
                  </span>
                  <button onClick={() => handleDeleteCategory(category._id)} className="delete-category-button">
                    Excluir
                  </button>
                  <button onClick={() => { setEditingCategory(category._id); setEditedCategoryName(category.name); }} className="edit-category-button">
                    Editar
                  </button>
                </>
              )}
            </li>
          ))}
        </ul>
        <div className="add-category">
          <input
            type="text"
            placeholder="Nova Categoria"
            value={newCategory}
            onChange={(e) => setNewCategory(e.target.value)}
          />
          <button onClick={handleAddCategory} className="add-category-button">
            +
          </button>
        </div>
      </div>
    </div>
  );
};

export default UploadAssets;
